module.exports = __webpack_public_path__ + "img/public/SiteIcons/carTypeIconNew.svg?33274768";